export default "__VITE_ASSET__BkvEtzFs__"